import { useRecoilState, useRecoilValue } from 'recoil';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { onsaProgressAtom } from '../../recoil/atoms/onsaProgressAtom';
import { getOnsaCurrentProductSelector } from '../../recoil/selectors/getOnsaCurrentProductSelector';
import { Grid, GridItem, Wizard } from '@flos/react-ui';
import OnsaProgressBar from '../../shared_components/OnsaProgressBar/OnsaProgressBar';
import { getAdditionalInformationConfig } from './additionalInformationStepsConfig';
import { getOnsaProgressSelector } from '../../recoil/selectors/getOnsaProgressSelector';

const AdditionalInformationPage: WizardPageComponent = () => {
    const { wizardGotoStep } = useWizardNavigation();
    const [onsaProgress, setOnsaProgress] = useRecoilState(onsaProgressAtom);
    const onsaNavigation = useRecoilValue(getOnsaProgressSelector);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const additionalInformationSteps = getAdditionalInformationConfig(currentProduct);

    const goNext = (): void => {
        wizardGotoStep(onsaNavigation.nextStep);
        setOnsaProgress((prevStep) => ({
            ...prevStep,
            currentStep: prevStep.currentStep + 1
        }));
    };

    const goPrevious = (): void => {
        wizardGotoStep(onsaNavigation.prevStep);
        setOnsaProgress((prevStep) => ({
            ...prevStep,
            currentStep: prevStep.currentStep - 1
        }));
    };

    if (!currentProduct) {
        return <></>;
    }

    return (
        <Wizard.Container currentStep={onsaProgress?.currentStep}>
            {additionalInformationSteps.map((step) => {
                const { id, Component } = step;
                return (
                    <Wizard.Pane key={id} hideProgress>
                        <Grid>
                            <GridItem span={8} colStart={3}>
                                <OnsaProgressBar />
                                <Component goNext={goNext} goPrevious={goPrevious} />
                            </GridItem>
                        </Grid>
                    </Wizard.Pane>
                );
            })}
        </Wizard.Container>
    );
};

export default AdditionalInformationPage;
